import { FC } from 'react';
import styled from 'styled-components';
import { TopDecorColor } from '../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/GenericComponentCssMatchCard';

const StatSectionContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 28px 20px 20px;
  background: linear-gradient(160deg, rgba(163, 27, 27, 0.1) 0%, rgba(10, 10, 10, 0.55) 100%);
  border: 1px solid rgba(163, 27, 27, 0.3);
  border-radius: 12px;
  color: white;
  cursor: pointer;
  overflow: hidden;
  gap: 12px;
  transition: transform 0.22s ease, border-color 0.22s ease, box-shadow 0.22s ease;

  &:hover {
    transform: translateY(-5px);
    border-color: rgba(163, 27, 27, 0.7);
    box-shadow: 0 8px 28px rgba(163, 27, 27, 0.18);
  }

  .section-label {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 2.5px;
    color: rgba(255, 255, 255, 0.55);
    margin: 0;
  }

  .wrestler-avatar {
    width: 120px;
    height: 120px;
    border: 2px solid rgba(163, 27, 27, 0.4);
    border-radius: 8px;
    overflow: hidden;
    flex-shrink: 0;
    transition: border-color 0.22s ease, box-shadow 0.22s ease;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: top;
      display: block;
    }
  }

  &:hover .wrestler-avatar {
    border-color: rgba(163, 27, 27, 0.8);
    box-shadow: 0 0 12px rgba(163, 27, 27, 0.2);
  }

  .wrestler-name {
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: rgba(255, 255, 255, 0.92);
    margin: 0;
  }

  .section-title {
    font-size: 12px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.45);
    text-align: center;
    margin: 0;
    letter-spacing: 0.3px;
  }
`;

interface Wrestler {
  avatar_path: string;
  name: string;
}

interface StatSectionProps {
  title: string;
  wrestler?: Wrestler;
  onClick: () => void;
}

const StatSection: FC<StatSectionProps> = ({ title, wrestler, onClick }) => {
  return (
    <StatSectionContainer className="stat-section-container" onClick={onClick}>
      <TopDecorColor />

      <p className="section-label">{title}</p>

      {wrestler && (
        <>
          <div className="wrestler-avatar">
            <img
              src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path}
              alt={wrestler.name}
            />
          </div>
          <span className="wrestler-name">{wrestler.name}</span>
        </>
      )}

      <p className="section-title">Vedi classifica completa →</p>
    </StatSectionContainer>
  );
};

export default StatSection;
